<template>
  <div class="content has-text-left">
    <div class="columns boxes">
      <div class="column is-5 has-text-centered">
        <div class="columns is-mobile">
          <div class="column is-three-quarters-mobile is-half">
            <div class="box">
              <span class="has-text-weight-bold is-size-6 has-text-black">{{$t("account_id").tTitle()}}</span>
              <hr class="is-marginless" />
              <p class="has-text-weight-bold is-size-4 has-text-primary">{{externalTransferAccount.ID}}</p>
            </div>
          </div>
          <div class="column is-three-quarters-mobile is-half">
            <div class="box">
              <span class="has-text-weight-bold is-size-6 has-text-black">{{$t("balance").tTitle()}}</span>
              <hr class="is-marginless" />
              <p class="has-text-weight-bold is-size-4 has-text-primary">{{$formatMoney(externalTransferAccount.balance, currencySymbols[externalTransferAccount.currency])}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="column has-text-right is-mobile is-offset-4 is-3-desktop actions">
        <router-link
          class="button is-fullwidth is-primary is-outlined"
          :to="'/' + Language + '/finance/internal-transfer'"
        >{{$t("internal_transfer").tUpper()}}</router-link>
        <div class="space"></div>
        <a
          class="button is-fullwidth is-primary"
          id="transferBtn"
          @click="externalTransferAccount.modalActive.transfer = true"
        >{{$t("external_transfer").tUpper()}}</a>
      </div>
    </div>
    <div class="is-clearfix"></div>
    <hr />
    <div class="columns is-variable is-1">
      <div class="column">
        <div class="field">
          <p class="control">
            <label class="label">{{$t("from_date").tUpper()}}</label>
            <datepicker
              v-model="filters.dateFrom"
              placeholder="YYYY-MM-DD"
              :config="{ dateFormat: 'Y-m-d', static: true }"
            ></datepicker>
          </p>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <p class="control">
            <label class="label">{{$t("to_date").tUpper()}}</label>
            <datepicker
              v-model="filters.dateTo"
              placeholder="YYYY-MM-DD"
              :config="{ dateFormat: 'Y-m-d', static: true }"
            ></datepicker>
          </p>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <div class="control">
            <label class="label">{{$t("type").tUpper()}}</label>
            <div class="select is-fullwidth">
              <select v-model="filters.extTrType">
                <option
                  selected
                  value
                ></option>
                <option value="send">{{$t("sent").tUpper()}}</option>
                <option value="receive">{{$t("received").tUpper()}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <p class="control">
            <label class="label">{{$t("reference_id").tUpper()}}</label>
            <input
              class="input"
              type="text"
              name="referenceID"
              value
              v-model="filters.referenceID"
            />
          </p>
        </div>
      </div>
      <div class="column bot">
        <button
          class="button is-primary is-fullwidth is-outlined"
          id="clearBTN"
          @click="clearFilters()"
        >{{$t("clear").tUpper()}}</button>
      </div>
      <div class="column bot">
        <button
          class="button is-primary is-fullwidth"
          id="searchBtn"
          @click="searchExternalTransfers()"
        >{{$t("search").tUpper()}}</button>
      </div>
    </div>

    <br />

    <div class="table-overflow">
      <table
        class="table is-striped is-responsive"
        :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
        id="external-transfers"
      >
        <thead>
          <tr>
            <th>{{$t("reference_id").tUpper()}}</th>
            <th>{{$t("from_account").tUpper()}}</th>
            <th>{{$t("to_account").tUpper()}}</th>
            <th>{{$t("amount").tUpper()}}</th>
            <th>{{$t("converted_amount").tUpper()}}</th>
            <th>{{$t("type").tUpper()}}</th>
            <th>{{$t("date").tUpper()}}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="ext in externalTransferAccount.history"
            :key="ext.reference_id"
          >
            <td>
              <span class="is-hidden-desktop has-text-weight-bold">{{ $t("reference_id").tTitle() }}:</span>
              {{ext.reference_id}}
            </td>
            <td>
              <span class="is-hidden-desktop has-text-weight-bold">{{ $t("from_account").tTitle() }}:</span>
              {{ext.from_account}}
            </td>
            <td>
              <span class="is-hidden-desktop has-text-weight-bold">{{ $t("to_account").tTitle() }}:</span>
              {{ext.to_account}}
            </td>
            <td>
              <span class="is-hidden-desktop has-text-weight-bold">{{ $t("amount").tTitle() }}:</span>
              {{ext.amount}}
            </td>
            <td>
              <span class="is-hidden-desktop has-text-weight-bold">{{ $t("converted_amount").tTitle() }}:</span>
              {{ext.converted_amount}}
            </td>
            <td>
              <span class="is-hidden-desktop has-text-weight-bold">{{ $t("type").tTitle() }}:</span>
              {{ext.type}}
            </td>
            <td>
              <span class="is-hidden-desktop has-text-weight-bold">{{ $t("date").tTitle() }}:</span>
              {{$formatDateTime(ext.created_at)}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination
      for="external-transfers"
      :records="pagination.total"
      :per-page="pagination.maxItemsPerPage"
      :chunk="4"
      :count-text="pagination.total + ' ' + $t('records') "
    ></pagination>

    <div
      class="modal"
      :class="{'is-active' : externalTransferAccount.modalActive.transfer}"
      id="transferToModal"
    >
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ $t("transfer_to_external_account").tUpper() }}</p>
          <button
            class="delete"
            @click="externalTransferAccount.modalActive.transfer = false"
          ></button>
        </header>
        <section class="modal-card-body">
          <form
            @submit.prevent
            data-vv-scope="form-transfer"
          >
            <div class="field">
              <label class="label has-text-left">{{ $t("amount").tUpper() }}</label>
              <p class="control has-icons-left has-icons-right">
                <input
                  v-validate="'required|min_value:20|max_value:'+externalTransferAccount.balance"
                  :class="{'input': true, 'is-danger': errors.has('form-transfer.amount') }"
                  id="amount"
                  name="amount"
                  type="number"
                  v-model="externalTransferAccount.amount"
                />
                <span
                  v-show="errors.has('form-transfer.amount')"
                  id="transferError"
                  :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
                  class="help is-danger animated"
                >{{ errors.first('form-transfer.amount') }}</span>
                <span class="icon is-small is-right">
                  <i class="fa fa-check"></i>
                </span>
              </p>
            </div>
            <br />
            <div>
              <label class="label has-text-left">{{ $t("account").tUpper() }}</label>
              <p class="control has-icons-left has-icons-right">
                <span class="select">
                  <select
                    id="selectLockedAccount"
                    v-model="externalTransferAccount.selectLockedAccountTAID"
                  >
                    <option
                      v-for="lta in externalTransferAccount.lockedAccounts"
                      :value="lta.external_id"
                    >{{lta.external_id}}</option>
                  </select>
                </span>
              </p>
            </div>
          </form>
        </section>
        <footer class="modal-card-foot reverse">
          <a
            class="button is-success"
            @click="executeTransferTo()"
          >{{$t('transfer').tUpper()}}</a>
          <a
            class="button"
            @click="externalTransferAccount.modalActive.transfer = false"
          >{{$t('cancel').tTitle()}}</a>
        </footer>
      </div>
    </div>

    <error-modal></error-modal>
  </div>
</template>

<script>
import { Pagination, PaginationEvent } from 'vue-pagination-2-bulma'
import { service } from '../../app'
import { mapActions, mapGetters } from 'vuex'
import api from '../../api'
import moment from 'moment'
import config from '../../config'
import Datepicker from 'vue-bulma-datepicker'
import ErrorModal from '../../components/ErrorModal'

export default {
  components: {
    Datepicker,
    Pagination,
    ErrorModal,
  },
  data: function () {
    return {
      externalTransferAccount: {
        ID: 0,
        currency: '',
        balance: 0,
        modalActive: {
          transfer: false,
        },
        history: [],
        amount: 0,
        lockedAccounts: [],
        selectLockedAccountTAID: 0,
      },
      currencySymbols: config.currencies,
      filters: {
        dateFrom: '',
        dateTo: '',
        extTrType: '',
        referenceID: '',
      },
      pagination: {
        page: 1,
        total: 1,
        maxItemsPerPage: 10,
      },
    }
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
      User: 'user/all',
    }),
  },
  watch: {
    'User.TA'(ta) {
      this.findTransferTA()
      this.searchExternalTransfers()
    },
    'externalTransferAccount.ID'(id) {
      this.findLockedChildTAs()
    },
  },
  mounted() {
    if (this.$store.state.TAs) {
      this.User.TA = this.$store.state.TAs
    }

    if (typeof this.User.info.ID !== 'undefined' && !this.TALoading) {
      this.TALoading = true
      api.GetTradingAccounts()
    }

    PaginationEvent.$on('vue-pagination::external-transfers', page => {
      this.pagination.page = page
      this.searchExternalTransfers()
    })

    this.styleAlterations()
  },
  methods: {
    clearFilters() {
      this.filters.dateFrom = '2000-01-01'
      this.filters.dateTo = moment(moment().add(1, 'days')).format('YYYY-MM-DD')
      this.filters.extTrType = ''
      this.filters.referenceID = ''
    },
    styleAlterations() {
      let wrappers = document.getElementsByClassName('flatpickr-wrapper')
      for (let i = 0; i < wrappers.length; i++) {
        wrappers[i].style.display = 'block'
      }
    },
    searchExternalTransfers() {
      service
        .post('/finance/external-transfer/history', {
          userID: this.User.info.ID,
          TAID: this.externalTransferAccount.ID,
          dateFrom: this.filters.dateFrom,
          dateTo: this.filters.dateTo,
          extTrType: this.filters.extTrType,
          referenceID: this.filters.referenceID,
          page: this.pagination.page,
        })
        .then(response => {
          this.externalTransferAccount.history = response.data.history
          this.pagination.total = response.data.count
        })
    },
    executeTransferTo() {
      this['logoLoader/set'](true)
      this.$validator
        .validateAll('form-transfer')
        .then(result => {
          if (!result) {
            document.getElementById('transferError').classList.add('shakeSubtle')
            setTimeout(function () {
              document.getElementById('transferError').classList.remove('shakeSubtle')
            }, 1200)
            this['logoLoader/set'](false)
          } else {
            service
              .post('/finance/external-transfer/transfer-to', {
                userID: this.User.info.ID,
                amount: this.externalTransferAccount.amount,
                fromTA: this.externalTransferAccount.ID,
                toTA: this.externalTransferAccount.selectLockedAccountTAID,
              })
              .then(response => {
                this.externalTransferAccount.modalActive.transfer = false

                api.GetTradingAccounts()
                this.searchExternalTransfers()
                this.$toasted.success(this.$t('external_transfer_processed_successfully').tTitle())
                this['logoLoader/set'](false)
              })
              .catch(error => {
                this.externalTransferAccount.modalActive.transfer = false
                this['logoLoader/set'](false)
                if (error.response.data.meta) {
                  let meta = error.response.data.meta
                  let tkey = config.API.translationKeyName
                  if (meta[tkey]) {
                    let trep = {}
                    if (meta[tkey] === 'error_min_balance_required_is') {
                      trep = { TAAccountType: meta['TAAccountType'], TAID: meta['TAID'], currency: meta['currency'], min: meta['min'] }
                    }
                    this['errorModal/set']({ active: true, text: this.$t(meta[tkey], trep).tTitle() })
                    return
                  }
                }
                this['errorModal/set']({ active: true, text: this.$t('error_request_failed').tTitle() })
              })
          }
        })
        .catch(() => {
          this['logoLoader/set'](false)
        })
    },
    findLockedChildTAs() {
      service
        .post('/ta/locked-TAs', {
          userID: this.User.info.ID,
          parentTAID: this.externalTransferAccount.ID,
        })
        .then(response => {
          if (response.data.TAs) {
            this.externalTransferAccount.lockedAccounts = response.data.TAs
            this.externalTransferAccount.selectLockedAccountTAID = this.externalTransferAccount.lockedAccounts[0].external_id
          }
        })
    },
    findTransferTA() {
      for (let i = 0; i < this.User.TA.length; i++) {
        if (this.User.TA[i].platform === 'transfer') {
          this.externalTransferAccount.ID = this.User.TA[i].external_id
          this.externalTransferAccount.currency = this.User.TA[i].currency
          this.externalTransferAccount.balance = this.User.TA[i].balance
          return
        }
      }
    },
    ...mapActions(['logoLoader/set', 'errorModal/set']),
  },
}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/initial-variables';
@import '../../assets/css/variables';

.column.bot {
  margin-top: auto;
  @media screen and (max-width: $mobile) {
    padding-bottom: 0;
  }
}
.space {
  margin: 10px 0 0;
}

.box {
  padding-top: 10px;
  padding-bottom: 10px;
}

.columns.boxes {
  .column {
    .is-size-4 {
      @media screen and (max-width: $mobile) {
        font-size: 14px !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?b120cf6a